import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10.827",
  cy: "10.825",
  r: "10.825",
  fill: "var(--background-color)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.826 0C13.8173 0 16.3672 1.0583 18.4766 3.17538C20.5934 5.29271 21.652 7.84283 21.652 10.826C21.652 13.8171 20.5934 16.3672 18.4766 18.4764C16.3672 20.5934 13.8173 21.652 10.826 21.652C7.84283 21.652 5.29271 20.5934 3.17538 18.4764C1.05854 16.3672 0 13.8171 0 10.826C0 7.84283 1.05854 5.29271 3.17538 3.17538C5.29271 1.0583 7.84283 0 10.826 0ZM16.4555 5.20826C14.9076 3.66063 13.0391 2.8826 10.8498 2.87466V18.7771C13.0391 18.7691 14.9076 17.9911 16.4555 16.4435C18.0034 14.8797 18.7771 13.0073 18.7771 10.826C18.7773 8.64467 18.0034 6.77202 16.4555 5.20826Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }